<template>
	<transition name="about">
		<div v-show="app.actives.about" class="about">
			<v-touch @tap="close_about()" class="about-bg"></v-touch>
			<div class="about-content">
				
				<div class="about-infos">
					<p v-html="texts[lang].about_p1"></p>
					<p v-html="texts[lang].about_p2"></p>
					<p class="buttons"><a href="https://www.paypal.me/christophecoyard" class="button"><icon file="beer" :size="24" />{{ texts[lang].pay_beer }}</a></p>
					<p>{{ texts[lang].about_p3 }} <a href="https://twitter.com/chris_coyard">@chris_coyard</a>.</p>
				</div>

				<div class="about-credits">
					<p>{{ texts[lang].game_icons }} : <a href="https://game-icons.net">game-icons.net</a></p>
					<p>{{ texts[lang].interface }} : <a href="https://feathericons.com">feathericons.com</a></p>
					<p>{{ texts[lang].sounds }} : <a href="https://freesound.org">freesound.org</a></p>
				</div>
				
			</div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'About',
	computed: Object.assign(mapGetters([ 'app', 'texts', 'lang' ]), {
		
	}),
	methods: {
		close_about: function() {
			this.$store.dispatch('set_about_visible', { visible: false })
		}
	}
}
</script>

<style lang="stylus">
@import '../assets/css/app'


.about-enter-active, .about-leave-active
	transition 0.25s easeOutQuart
	.about-bg
		transition 0.25s easeOutQuart
	.about-content
		transition 0.25s easeOutQuart
		
.about-enter
	.about-bg
		opacity 0
	.about-content
		opacity 0
		transform translate3D(0, 24px, 0)

.about-leave-to
	opacity 0


.about
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	.about-bg
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background alpha(dark, 75%)
	.about-content
		position absolute
		top 56px
		left 4px
		width 300px
		padding 16px
		background light
		border-radius 8px
		font-size 14px
		line-height 18px
		&:before
			content ''
			position absolute
			left 16px
			top -8px
			width 0
			height 0
			border-style solid
			border-width 0 8px 8px 8px
			border-color transparent transparent light transparent
		.about-infos
			p
				margin 0 0 8px 0
				color #666
				a
					text-decoration underline
					color #666
				strong
					color #333
					font-weight 400
			.buttons
				.button
					display inline-block
					height 48px
					padding 8px 12px
					border-radius 4px
					background green
					text-decoration none
					color #fff
					line-height (32px - 2px)
					box-shadow inset 0 -4px 0 0 alpha(#000, 10%)
					.icon
						float left
						margin 3px 8px 0 0
		.about-credits
			margin 24px 0 0 0
			padding 24px 0 0 0
			font-size 12px
			line-height 16px
			color #aaa
			&:before
				content ''
				position absolute
				left 25%
				right 25%
				top 0
				height 2px
				width 50%
				background #eee
			a
				color #888

</style>



// WEBPACK FOOTER //
// src/components/About.vue